import { Link2 } from "lucide-react"

import { lazyPage } from "../lazy-page"
import { defineDashboardModule } from "../types"

export const links = defineDashboardModule({
  id: "links",
  nav: [{ group: "Publishing", title: "Links", to: "/links", icon: Link2 }],
  routes: [
    {
      path: "/links",
      component: lazyPage(() => import("./routes/links-page"), "LinksPage"),
    },
    {
      path: "/links/:id",
      component: lazyPage(
        () => import("./routes/link-detail"),
        "LinkDetailPage"
      ),
    },
  ],
})
